<template>
  <div>
    <p :class="['link', `ellipsis-${titleShowLine}line`]" @click="goDetail(data.id)">
      {{ data.appealTitle }}
    </p>
    <el-tag v-if="showHighType" type="danger" size="mini" style="margin-top:4px">高危类型：{{ highTypeMap[data.highType] }}</el-tag>
  </div>
</template>

<script>
import {
  highTypeMap
} from '../const'

export default {
  name: 'TaskInfoMod',
  props: {
    data: Object,
    showHighType: {
      type: Boolean,
      default: true
    },
    titleShowLine: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      highTypeMap
    }
  },
  methods: {
    goDetail(id) {
      this.$router.open({ name: 'appealEdit', query: { id } })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
